import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../authentication/authentication.service';

@Component({
    selector: 'app-without-permission',
    templateUrl: './without-permission.component.html',
    styleUrls: ['./without-permission.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class WithoutPermissionComponent implements OnInit {
    expirado = false;

    constructor(
        private router: Router,
        private authService: AuthenticationService,
        private modalService: NgbModal) {
    }

    ngOnInit() {
        this.modalService.dismissAll();
    }

    tryLogin() {
        this.authService.resetToken();
        this.router.navigate(['']);
    }

}
